export const MARKETING_ACTIONS_TRANSLATION_NAMESPACE = "marketing-actions";

export const MARKETING_ACTIONS_CREATE_VIEW_TK = "MARKETING_ACTIONS_CREATE_VIEW_TK";

export const MARKETING_ACTIONS_COMMON_TABLE_TK = "MARKETING_ACTIONS_COMMON_TABLE_TK";
